import { EventPagesAPI } from "@/api/apis";
import checkSiteConfig from "@/api/checkSiteConfig";
import { failAlert, successAlert } from "@/common/alert";
import Layout from "@/components/layout/Layout";
import { useQuery } from "@tanstack/react-query";
import * as GE from "../../../components/group-event/GroupEvent.styles";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import TypeThird from "@/components/group-event/types/typeThird";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { GPTypeThirdSchema } from "@/common/validation";
import { EmptyWrapper } from "@/components/cart/cart-styles";
import { useGetUserInfo } from "@/api/getUserInfo";
import { useRouter } from "next/router";
import { QUERY_KEYS } from "@common/queryKeys";
import { SeoMeta } from "@/utils/seo/SeoMeta";

const PrototypePage = () => {
  const router = useRouter();
  const [isActive, setIsActive] = useState(false); //활성화

  const {
    data: userInfoList,
    isLoading: userInfoLoading,
    refetch,
  } = useGetUserInfo();
  // siteConfig 조회
  const { data: siteConfig } = useQuery({
    queryKey: QUERY_KEYS.SITE_CONFING.INDEX,
    queryFn: async () => {
      const body = {
        modes: "Config",
        division: "store",
        channel:
          sessionStorage.getItem("channelName") === "바로고" ? "BAROGO" : "",
      };
      const res = await checkSiteConfig(body);
      if (res?.Code === "0000") {
        if (res.Data.channel?.token) {
          sessionStorage.setItem("channel", res.Data.channel.token);
          sessionStorage.setItem("channelName", res.Data.channel.company);
        }
        return res.Data;
      }
      throw new Error("사이트 설정 조회 실패");
    },
  });

  const prototypeCode = siteConfig?.Prototype;

  const {
    data: detailData,
    isLoading: detailDataLoaing,
    refetch: refetchDetailData,
  } = useQuery({
    queryKey: prototypeCode
      ? QUERY_KEYS.CUSTOMIZING.PROTOTYPE.DETAIL(prototypeCode)
      : [],
    queryFn: async () => {
      if (!prototypeCode) return null;
      const body = {
        modes: "ViewSet",
        code: siteConfig?.Prototype,
      };
      const res = await EventPagesAPI(body);
      if (res?.Code === "0000") {
        setIsActive(res.Data?.Row?.useYn !== null);
        return { ...res.Data?.Row, info: res?.Data?.Info };
      }
      throw new Error(res.Data?.Msg || "조회 실패");
    },
    enabled: !!siteConfig?.Prototype,
    staleTime: 0,
    refetchOnMount: false,
    onError: (error) => {
      failAlert(error.message);
    },
  });

  useEffect(() => {
    if (siteConfig?.Prototype) {
      refetchDetailData();
    }
  }, [siteConfig?.Prototype]);

  // form
  const typeThirdOptions = {
    resolver: yupResolver(GPTypeThirdSchema),
    mode: "onChange",
  };
  const methods = useForm(typeThirdOptions);
  const { handleSubmit } = methods;

  const [inputData, setInputData] = useState({
    check: false,
  });
  const [isFormLoading, setIsFormLoading] = useState(false);

  const handleInputData = (e, key) => {
    if (key === "check") {
      setInputData({ ...inputData, [key]: e.target.checked });
      return;
    }
    setInputData({ ...inputData, [key]: e.target.value });
  };

  // 문의 등록
  const onSubmit = async (data) => {
    setIsFormLoading(true);
    try {
      const body = {
        modes: "InsertSet",
        code: siteConfig?.Promotion,
        ...data,
      };

      const res = await EventPagesAPI(body);
      if (res.Code === "0000") {
        successAlert(res.Data?.Msg || "등록되었습니다.");
        methods.reset(); //form 초기화
        setInputData({ check: false }); //inputdata 초기화
        refetch(); //유저 정보 재조회
        router.reload(); // 새로고침
      } else if (res.Code === "8888") {
      } else {
        failAlert(res.Data?.Msg || "등록 실패입니다.");
      }
    } catch (error) {
      failAlert("오류가 발생했습니다.");
    } finally {
      setIsFormLoading(false);
    }
    methods.reset();
    setInputData({ check: false });
  };

  return (
    <>
      <Layout
        parent="홈"
        sub={"맞춤제작"}
        subTitle={"시제품 제작"}
        pageTitle={SeoMeta.prototypeCreation.title}
        pageDesc={SeoMeta.prototypeCreation.description}
        pageKeyword={SeoMeta.prototypeCreation.keywords}
      >
        <GE.Container className="container">
          {!isActive ? (
            // {/* 데이터 x */}
            <EmptyWrapper>
              <img
                src="https://image.caretbio.com/store/webhard/지칼렛_탄소_420x200.png"
                alt="empty-edu"
              />
              <h4 className="title">현재 문의가능한 시제품이 없습니다.</h4>
              <div>
                <Link href="/esg-guide/letter">
                  <a className="btn">ESG 뉴스레터 보러가기</a>
                </Link>
              </div>
            </EmptyWrapper>
          ) : (
            //  {/* 데이터 o */}
            <GE.DetailWrapper>
              <GE.DetailSection className="single-content">
                <h3>{detailData?.title}</h3>
                <div
                  dangerouslySetInnerHTML={{ __html: detailData?.content }}
                  className="ck-content"
                />
              </GE.DetailSection>
              <FormProvider {...methods}>
                <GE.StickySection onSubmit={handleSubmit(onSubmit)}>
                  <h5 className="mb-3">시제품 제작 신청</h5>
                  <GE.StickyBody>
                    <TypeThird
                      userInfoList={userInfoList?.Data}
                      inputData={inputData}
                      setInputData={setInputData}
                      handleInputData={handleInputData}
                    />
                  </GE.StickyBody>
                  <GE.StickyFooter>
                    <button type="submit" className="btn confirm">
                      {isFormLoading ? "처리중..." : "문의하기"}
                    </button>
                  </GE.StickyFooter>
                </GE.StickySection>
              </FormProvider>
            </GE.DetailWrapper>
          )}
        </GE.Container>
      </Layout>
    </>
  );
};
export default PrototypePage;
